<div
  class="bulk-spinner d-flex flex-column justify-content-center align-items-center"
>
  <div class="py-3">
    <span class="fw-bolder text-normal text-white">
      {{ message || rawInitialMessage}}
    </span>
  </div>
  <div class="d-flex justify-content-center">
    <div class="loader" [style.--inset-percent]="value + '%'"></div>
  </div>
</div>
